import { useI18n } from '@i18n/I18nProvider'
import { Icon } from '@ui/Icon'
import { Link } from 'wouter'
import { LanguageSwitcher } from './LanguageSwitcher'

export const Header = () => {
	const { t } = useI18n()
	return (
		<header className="sticky top-0 z-20 bg-olive-900 text-white pt-[env(safe-area-inset-top)]">
			<div className="mx-auto flex h-14 max-w-xl items-center justify-between px-4">
				<Link href="/" className="flex items-center gap-2 font-bold text-white">
					<Icon name="tree" className="size-7" />
					{t('app.name')}
				</Link>
				<LanguageSwitcher />
			</div>
		</header>
	)
}
